import { createContext, useContext, type ReactNode } from 'react'
import type { UseAudioOptions } from './use-audio'

const AudioOptionsContext = createContext<UseAudioOptions | undefined>(
  undefined,
)

export function AudioOptionsProvider({
  children,
  value,
}: {
  children: ReactNode
  value?: UseAudioOptions
}) {
  return (
    <AudioOptionsContext.Provider value={value}>
      {children}
    </AudioOptionsContext.Provider>
  )
}

export function useAudioOptions(): UseAudioOptions | undefined {
  return useContext(AudioOptionsContext)
}
